export default __webpack_public_path__ + "static/uriel-soberanes-mx-vk-w-pi-ja-ls-unsplash-7e4c43e9d6656745387d4e52cff8afdb.png";